const PLAN_DETAILS = {
  starter: {
    label: "Starter",
    supply: "30-Day Supply",
    bottles: "1 Bottle",
  },
  routine: {
    label: "Routine",
    supply: "60-Day Supply",
    bottles: "2 Bottles",
  },
  complete: {
    label: "Complete",
    supply: "90-Day Supply",
    bottles: "3 Bottles",
  },
};

function normalizePlan(value) {
  return String(value || "").trim().toLowerCase();
}

function planKeyFromValue(value) {
  const normalized = normalizePlan(value);
  if (normalized.includes("routine")) return "routine";
  if (normalized.includes("complete")) return "complete";
  return "starter";
}

function syncRoutineProperties(picker) {
  const input = picker.querySelector(".variant-option--purchase-plan input:checked");
  const form = picker.closest(".shopify-section, dialog")?.querySelector('form[data-type="add-to-cart-form"]');

  if (!input || !form) return;

  const planKey = planKeyFromValue(input.value);
  const card = input.closest("[data-routine-card]");
  const planDetails = PLAN_DETAILS[planKey] || {
    label: input.value,
    supply: card?.dataset.supply || "",
    bottles: card?.dataset.bottles || "",
  };

  const properties = {
    "properties[Purchase Plan]": planDetails.label,
    "properties[Plan Details]": [planDetails.supply, planDetails.bottles].filter(Boolean).join(" - "),
  };

  Object.entries(properties).forEach(([name, value]) => {
    let propertyInput = Array.from(form.querySelectorAll("input[data-routine-property-input]")).find(
      (input) => input.name === name
    );
    if (!propertyInput) {
      propertyInput = document.createElement("input");
      propertyInput.type = "hidden";
      propertyInput.name = name;
      propertyInput.dataset.routinePropertyInput = "";
      form.append(propertyInput);
    }
    propertyInput.value = value;
  });
}

function updateSelectedCards(picker) {
  picker.querySelectorAll("[data-routine-card]").forEach((card) => {
    const input = card.querySelector("input");
    card.classList.toggle("is-selected", Boolean(input?.checked));
  });
}

function selectDefaultRoutine(picker) {
  const params = new URLSearchParams(window.location.search);
  if (params.has("variant")) return;

  const routineInput = Array.from(picker.querySelectorAll(".variant-option--purchase-plan input")).find(
    (input) => planKeyFromValue(input.value) === "routine" && !input.disabled && input.getAttribute("aria-disabled") !== "true"
  );

  if (routineInput && !routineInput.checked) {
    routineInput.checked = true;
    routineInput.dispatchEvent(new Event("change", { bubbles: true }));
  }
}

function initializeRoutinePicker(picker) {
  updateSelectedCards(picker);
  syncRoutineProperties(picker);
  selectDefaultRoutine(picker);
}

document.addEventListener("change", (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement)) return;

  const picker = input.closest("variant-picker.variant-picker--purchase-plan");
  if (!picker) return;

  updateSelectedCards(picker);
  syncRoutineProperties(picker);
});

function initAllRoutinePickers() {
  document.querySelectorAll("variant-picker.variant-picker--purchase-plan").forEach(initializeRoutinePicker);
}

document.addEventListener("DOMContentLoaded", initAllRoutinePickers);
document.addEventListener("shopify:section:load", initAllRoutinePickers);

if (document.readyState !== "loading") {
  initAllRoutinePickers();
}
